import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { Facebook, Twitter, Instagram, Linkedin } from "lucide-react";
export default function Footer() {
  return <section id="footer" className="bg-background py-20 border-t border-border">
      <div className="container mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-20">
          {}
          <div className="flex flex-col gap-6">
            <Link to="/HomePage" className="block w-fit">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1556727/img/oralguide_logo.png" alt="OralGuide Logo" className="h-7 w-auto object-contain" />
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed font-sans">
              Simplifying dental health for the general public with high-quality, evidence-based guides.
            </p>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h4 className="font-sans font-medium text-foreground text-sm tracking-wide">
              Explore
            </h4>
            <nav className="flex flex-col gap-3">
              <Link to="/HomePage" className="text-sm text-muted-foreground hover:text-primary transition-colors font-sans w-fit">
                Home
              </Link>
              <Link to="/KnowledgeHubPage" className="text-sm text-muted-foreground hover:text-primary transition-colors font-sans w-fit">
                Knowledge Hub
              </Link>
            </nav>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h4 className="font-sans font-medium text-foreground text-sm tracking-wide">
              Company
            </h4>
            <nav className="flex flex-col gap-3">
              <Link to="/OurPhilosophyPage" className="text-sm text-muted-foreground hover:text-primary transition-colors font-sans w-fit">
                Our Philosophy
              </Link>
              <Link to="/DentalMythsPage" className="text-sm text-muted-foreground hover:text-primary transition-colors font-sans w-fit">
                Dental Myths
              </Link>
            </nav>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h4 className="font-sans font-medium text-foreground text-sm tracking-wide">
              Connect
            </h4>
            <div className="flex gap-4">
              <Link to="#" aria-label="Facebook" className="text-muted-foreground hover:text-primary transition-colors">
                <Facebook className="size-5 stroke-1" />
              </Link>
              <Link to="#" aria-label="Twitter" className="text-muted-foreground hover:text-primary transition-colors">
                <Twitter className="size-5 stroke-1" />
              </Link>
              <Link to="#" aria-label="Instagram" className="text-muted-foreground hover:text-primary transition-colors">
                <Instagram className="size-5 stroke-1" />
              </Link>
              <Link to="#" aria-label="LinkedIn" className="text-muted-foreground hover:text-primary transition-colors">
                <Linkedin className="size-5 stroke-1" />
              </Link>
            </div>
          </div>
        </div>

        <Separator className="mb-8 bg-border/60" />

        {}
        <div className="flex flex-col items-center text-center">
          <p className="font-mono text-[10px] text-muted-foreground/70 max-w-4xl leading-relaxed">
            © {new Date().getFullYear()} OralGuide. All rights reserved. This
            website is an informational hub intended for educational purposes
            only. The content provided here is not a substitute for professional
            medical advice, diagnosis, or treatment. Always seek the advice of
            your dentist or other qualified health provider with any questions
            you may have regarding a medical condition.
          </p>
        </div>
      </div>
    </section>;
}